import React from 'react'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'

import { isEmptyOrNil } from 'libs/empty'
import clsx from 'clsx'

const StackedBarChart = (props) => {
  const { data } = props

  const summary = data.reduce((acc, obj) => acc + obj.value, 0)
  return (
    <>
      {isEmptyOrNil(data) ? null : (
        <div
          className="flex"
          style={{
            width: '100%',
            height: '14px',
          }}
        >
          {summary === 0 ? (
            <div
              className={clsx('h-full rounded-lg')}
              style={{
                width: '100%',
                backgroundColor: '#808080',
              }}
            ></div>
          ) : (
            <>
              {data.map((list, index) => (
                <Tooltip
                  disableHoverListener={isNil(list.lableTooltip)}
                  title={list.lableTooltip ?? list.name}
                  arrow
                  key={index}
                >
                  {list.value === 0 ? (
                    <></>
                  ) : (
                    <div
                      className={clsx(
                        'h-full first:rounded-l-lg last:rounded-r-lg',
                      )}
                      style={{
                        width: `${Math.ceil((list.value / summary) * 100)}%`,
                        backgroundColor: list.color,
                      }}
                    ></div>
                  )}
                </Tooltip>
              ))}
            </>
          )}
        </div>
      )}
    </>
  )
}

const valuePropTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  lableTooltip: PropTypes.object,
  value: PropTypes.number,
}
StackedBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(valuePropTypes)).isRequired,
}

export default StackedBarChart
